export const educationData = [
    {
        id: 1,
        institution: 'Masai School',
        course: 'Full Stack Web Development',
        startYear: 'Dec 2021',
        endYear: 'Jul 2022',
        Grade: "A"
    },
    {
        id: 2,
        institution: "KLE's KLE College of Engineering & Technology, Chikkodi",
        course: 'Bachelor of Engineering',
        startYear: 'Jul 2016',
        endYear: 'Aug 2020',
        Grade: "Last 4 Semesters Aggregate:- 8.1 CGPA | 8 Semesters Aggregate:- 7.1 CGPA"
    },
    {
        id: 3,
        institution: 'Kendriya Vidyalaya No.2 ,Belagavi',
        course: '12th',
        startYear: 'May 2015',
        endYear: 'May 2016',
        Grade: "73%"
    },
    {
        id: 3,
        institution: 'Kendriya Vidyalaya No.2 ,Belagavi',
        course: '10th',
        startYear: 'May 2013',
        endYear: 'May 2014',
        Grade: "8.4 CGPA"
    },
]